// extracted by mini-css-extract-plugin
module.exports = {"download-banner-comp":"DownloadStarted_download-banner-comp__EbkVX"};